import { GridPaginationModel } from "@mui/x-data-grid-pro";
import { filterNulls } from "src/utils/arrays.ts";

export const mergeRowClassNames = (...classNames: (string | undefined)[]): string => {
	return filterNulls(classNames).join(" ");
};

export const DEFAULT_PAGINATION_MODEL: GridPaginationModel = {
	pageSize: 100,
	page: 0
};
